import { createStore } from "vuex";
import { queryMyselfInfo } from "@/services/user/index.js";
//1. 创建
var store = createStore({
  state: {
    //TODO:登录后的token,1天失效
    storeToken: "",
    //用户信息: 导航权限 店铺权限
    userInfo: {},
    //全量导航
    navList: [
      /* 系统管理 */
      {
        id: "1",
        label: "系统管理",
        icon: "settings",
        routerName: "Management",
        children: [
          {
            id: "1-4-4",
            label: "超级管理员账号", //包括控制门店的数量
            routerName: "MallAdmin",
            path: "/management/accounts/admin",
          },
          {
            id: "1-5",
            label: "子账号管理",
            routerName: "PermissionAdmin",
            path: "/management/accounts/subAdmin",
          },
          {
            id: "1-6",
            label: "系统参数配置",
            routerName: "SysConfig",
            path: "/management/sysConfig",
          },
        ],
      },
      {
        id: "9",
        label: "用户管理",
        icon: "users",
        routerName: "UserManagement",
        path: "/management/user",
        children: [
          {
            id: "9-1",
            label: "用户列表",
            routerName: "MemberList",
            path: "/management/user/userList",
          },
          {
            id: "9-2",
            label: "交易记录",
            routerName: "MemberRecord",
            path: "/management/user/transactions",
          },
        ],
      },
      // {
      //   id: "7",
      //   label: "商家服务",
      //   icon: "el-icon-s-custom",
      //   routerName: "Examine",
      //   children: [
      //     {
      //       id: "7-1",
      //       label: "续费",
      //       routerName: "Payment",
      //       path: "/management/merchant/payment",
      //     },

      //     {
      //       id: "7-2",
      //       label: "使用指南",
      //       routerName: "",
      //       path: "",
      //     },
      //     {
      //       id: "7-3",
      //       label: "技术支持",
      //       routerName: "",
      //       path: "",
      //     },
      //   ],
      // },
      {
        id: "8",
        label: "网站端配置",
        icon: "globe",
        routerName: "WebCenter",
        children: [
          {
            id: "8-1",
            label: "意见反馈",
            routerName: "Feedback",
            path: "/management/webCenter/feedback",
          },
          {
            id: "8-2",
            label: "站内通知管理",
            routerName: "Notifications",
            path: "/management/webCenter/notifications",
          },
        ],
      },
      {
        id: "11",
        label: "机构管理",
        icon: "building",
        routerName: "Institution",
        children: [
          {
            id: "11-1",
            label: "机构列表",
            routerName: "InstitutionList",
            path: "/management/institution/institutionList",
          },
          {
            id: "11-2",
            label: "机构类型",
            routerName: "InstitutionTypes",
            path: "/management/institution/institutionTypes",
          },
          {
            id: "11-3",
            label: "展览列表",
            routerName: "ExhibitionList",
            path: "/management/institution/exhibitionList",
          },
        ],
      },
      {
        id: "12",
        label: "作品管理",
        icon: "artwork",
        routerName: "ArtworkManage",
        children: [
          {
            id: "12-1",
            label: "国家与城市",
            routerName: "CountryCities",
            path: "/management/artworkManage/countryCities",
          },
        ],
      },
      {
        id: "10",
        label: "项目进度",
        icon: "workspace",
        routerName: "Workspace",
        path: "/management/workspace",
      },
    ],
    //登录后筛选的导航
    filterNavList: [],
    //高亮导航项
    active: "",
  },
  //变更状态
  mutations: {
    updataUserInfo(state, value) {
      state.userInfo = value;
    },
    updataFilterNavList(state, value) {
      state.filterNavList = value;
    },
    updataActive(state, value) {
      state.active = value;
    },
  },
  actions: {
    /* 用户信息权限,店铺信息初始化 */
    async getUserInfoAction({ commit, state, dispatch }) {
      const userInfo = await queryMyselfInfo();
      if (!userInfo || userInfo.code !== 200 || !userInfo.data) {
        return { code: 201, routerName: "Errow", message: "获取用户信息失败" };
      }

      commit("updataUserInfo", userInfo.data);

      //根据用户权限初始化导航数据
      var copyNavList = JSON.parse(JSON.stringify(state.navList));

      // 超级管理员(grade===3)拥有全部权限，跳过role_id筛选
      if (state.userInfo.grade === 3) {
        commit("updataFilterNavList", copyNavList);
      } else {
        // 非超级管理员需要role_id
        if (!state.userInfo.role_id) {
          return {
            code: 201,
            routerName: "Errow",
            message: "当前账号权限不足",
          };
        }
        var roleList = state.userInfo.role_id?.split(",");
        await dispatch("getFilterNavListAction", {
          copyNavList,
          roleList,
        });
        commit("updataFilterNavList", copyNavList); //根据用户权限完成导航筛选
      }

      //定位第一个导航
      const routerName = await dispatch("findFirstRouterName", copyNavList);

      return new Promise((reslove, reject) => {
        reslove({
          code: 200,
          routerName,
        });
      });
    },

    /* 导航筛选 */
    async getFilterNavListAction(
      { dispatch, commit },
      { copyNavList, roleList },
    ) {
      for (var index = copyNavList.length - 1; index >= 0; index--) {
        if (
          copyNavList[index]?.children &&
          copyNavList[index]?.children.length > 0 &&
          roleList?.indexOf(copyNavList[index].id) >= 0
        ) {
          await dispatch("getFilterNavListAction", {
            copyNavList: copyNavList[index].children,
            roleList: roleList,
          });
        }
        if (roleList?.indexOf(copyNavList[index].id) < 0) {
          copyNavList.splice(index, 1);
        }
      }
    },

    /*  找到第一个导航最深层routerName */
    async findFirstRouterName({ dispatch, commit }, copyNavList) {
      if (copyNavList[0]?.children && copyNavList[0]?.children.length > 0) {
        return await dispatch("findFirstRouterName", copyNavList[0]?.children);
      } else {
        return copyNavList[0].routerName;
      }
    },

    /* 找到导航active */
    async findActive({ dispatch, commit }, { filterNavList, path }) {
      for (let index = 0; index < filterNavList.length; index++) {
        if (filterNavList[index]?.path === path) {
          commit("updataActive", filterNavList[index]?.id);
        }
        if (
          filterNavList[index]?.children &&
          filterNavList[index]?.children.length > 0 &&
          filterNavList[index]?.path !== path
        ) {
          await dispatch("findActive", {
            filterNavList: filterNavList[index]?.children,
            path,
          });
        }
      }
    },
  },

  /* 计算属性 */
  getters: {},
});
export default store;
